import http from './http';

export default {
  toggleLikes(payload) {
    return http.post('/ajax/toggleLikes', payload);
  },
};
